import * as React from 'react';
import { connect } from 'react-redux';

import {
  createStyles,
  Theme,
  Typography,
  WithStyles,
  withStyles
} from '@material-ui/core';
import { CheckBoxRounded } from '@material-ui/icons';

import { ILieuucationMapProperties } from '@lieuu/core';

import { IMapFilters, IStore, IUserState } from '@reducers';

import { getNumericalScore } from './getScore';

const styles = (theme: Theme) =>
  createStyles({
    container: {
      padding: theme.spacing(2),
      maxWidth: 300
      // color: 'inherit'
    },
    title: {
      display: 'flex',
      alignItems: 'center'
    },
    checkbox: {
      marginLeft: theme.spacing(1),
      color: theme.palette.secondary.main
    }
  });

interface IProps {
  properties: ILieuucationMapProperties;
  filters: IMapFilters;
}

const MapPopup: React.FC<WithStyles<typeof styles> & IUserState & IProps> = ({
  classes,
  properties,
  user,
  filters
}) => {
  const score = getNumericalScore(properties, filters);

  const viewedIds =
    (user &&
      user.viewedLieuucations &&
      user.viewedLieuucations.map((e) => e.internalId)) ||
    [];

  return (
    <div className={classes.container}>
      <div className={classes.title}>
        <Typography variant="h6">{properties.name}</Typography>
        {viewedIds.includes(properties.internalId) && (
          <CheckBoxRounded className={classes.checkbox} fontSize="small" />
        )}
      </div>
      <Typography>
        {
          'Compared to the surrounding areas in this city, this neighborhood meets '
        }
        <b>{score > 0.75 ? 'most' : score > 0.5 ? 'some' : 'not a lot'}</b>
        {' of your criteria.'}
      </Typography>
    </div>
  );
};

export default withStyles(styles)(
  connect((state: IStore): IUserState => state.user)(MapPopup)
);
